import { Component, OnInit } from '@angular/core';
import { PlayerService } from 'src/app/services/player.service';
import { Player } from 'src/app/objects/player';
import { MatDialog } from '@angular/material/dialog';
import { PaymentFormComponent } from 'src/app/components/payment-form/payment-form.component';
import { EventService } from 'src/app/services/event.service';
import { GroupService } from 'src/app/services/group.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Group } from 'src/app/objects/group';
import { Router } from '@angular/router';

@Component({
  selector: 's18-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit {
  player: Player;
  group: Group;
  availablePlans: any[];
  invoices: any[];
  current_plan: any;
  showUpgradeOptions: boolean = false;
  updatingCard: boolean = false;
  cancelling: boolean = false;
  reactivating: boolean = false;
  subscription: any;
  paymentMethod: any;
  product: any;
  usga_club_id: number = 0;
  error: string = "";

  constructor(
    private playerService: PlayerService,
    private localStorage: LocalStorageService,
    private dialog: MatDialog,
    private groupService: GroupService,
    private router: Router
  ) { }

  ngOnInit() {
    this.player = this.playerService.getLoggedInPlayerInfo();
    if (this.player.subscription_id) {
      this.fetchSubStatistics()
    }
    this.getAvailablePlans();
    this.getGroupInfo();
  }

  fetchSubStatistics() {
    this.getSubscriptionInfo()
    this.getPaymentMethod();
    this.getPastInvoices();
  }

  findAClub() {
    this.router.navigateByUrl("/clubs/search");
  }

  getGroupInfo() {
    if (this.player.default_usga_club_id > 0) {
      this.usga_club_id = this.player.default_usga_club_id;
    } else {
      this.usga_club_id = +this.localStorage.get("usga_club_id");
    }

    if (this.usga_club_id == 0) {
      return;
    }

    this.groupService.getGroupByUsgaClubId(this.usga_club_id)
      .subscribe(resp => {
        this.group = JSON.parse(resp.d);
        console.log(this.group);
      }, err => {

      });
  }

  getSubscriptionInfo() {
    this.groupService.getSubscriptionInfo(this.player.player_id.toString(), this.player.subscription_id)
      .subscribe(resp => {
        this.subscription = JSON.parse(resp.d);
        this.current_plan = this.subscription.plan;
        this.reactivating = false;
        this.cancelling = false;
        this.showUpgradeOptions = false;
      }, err => {
        console.log(err);
      }
      );
  }

  getPaymentMethod() {
    this.groupService.getPaymentMethod(this.player.stripe_customer_id)
      .subscribe(resp => {
        this.paymentMethod = JSON.parse(resp.d).paymentMethod;
        this.updatingCard = false;
      }, err => {
        console.log(err);
      });
  }

  getPastInvoices() {
    this.playerService.getPastInvoices(this.player.subscription_id, 10)
      .subscribe(resp => {
        this.invoices = JSON.parse(resp.d).invoices;
        console.log(this.invoices);
      }, err => {
        console.log(err);
      })
  }

  cancelSubscription() {
    this.cancelling = true;
    this.playerService.cancelSubscription(this.subscription.id)
      .subscribe(resp => {
        this.getSubscriptionInfo();
      }, err => {
        console.log(err);
      });
  }

  reactivateSubscription() {
    this.reactivating = true;
    this.playerService.reactivateSubscription(this.subscription.id)
      .subscribe(resp => {
        this.getSubscriptionInfo();
      }, err => {
        console.log(err);
      });
  }

  getAvailablePlans() {
    this.playerService.getAvailablePlans("handicap_plus")
      .subscribe(resp => {
        this.availablePlans = JSON.parse(resp.d).plans.filter(plan => plan.metadata.medium === "desktop");
        console.log(this.availablePlans);
        this.product = JSON.parse(resp.d).product;
        console.log(this.product);
      }, err => {
        console.log(err);
      });
  }

  selectPlan(plan: any) {
    let dialogRef = this.dialog.open(PaymentFormComponent,
      {
        width: '400px',
        data: {
          amount: plan.amount / 100,
          frequency: 1,
          trial: plan.trial_period_days
        }
      }
    );

    dialogRef.afterClosed().subscribe(token => {
      if (token.status !== 'failed') {
        plan.saving = true;
        this.playerService.subscribeToIndividualPlan(plan.id, token.id, this.player.player_id, token.couponCode, this.group.usga_club_id)
          .subscribe(resp => {
            var subscription = JSON.parse(resp.d).subscription;
            this.player.subscription_id = subscription.id;
            this.playerService.refetchPlayerInfo(this.player.player_id)
              .subscribe(resp => {
                var player = JSON.parse(resp.d);
                this.localStorage.set("playerInfo", player);
                this.player = this.playerService.getLoggedInPlayerInfo();
                this.fetchSubStatistics();
                plan.saving = false;
              });
          }, err => {
            plan.saving = false;
            console.log(err);
            this.error = err.error.Message;
          });
      }
    }, err => {
      console.log(err);
    });

  }

  goToProfile() {
    this.router.navigateByUrl("/profile");
  }

  updateCard() {
    var dialogRef = this.dialog.open(PaymentFormComponent, {
      width: '450px',
      data: {
        showAmount: false
      }
    });

    dialogRef.afterClosed().subscribe(token => {
      if (token.status !== 'failed') {
        this.updatingCard = true;
        this.groupService.UpdatePaymentMethod(this.player.stripe_customer_id, token.id)
          .subscribe(resp => {
            this.getPaymentMethod();
          }, err => {
            console.log(err);
          });
      }
    }, err => {
      console.log(err);
    });
  }

  viewInvoice(invoice: any) {
    window.open(invoice.hosted_invoice_url, '_blank');
  }

  manageRounds() {
    this.router.navigateByUrl("/dashboard/4")
  }

}
